var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      attrs: { size: "lg" },
      on: { hide: _vm.closeModal },
      model: {
        value: _vm.mutableModalOpened,
        callback: function ($$v) {
          _vm.mutableModalOpened = $$v
        },
        expression: "mutableModalOpened",
      },
    },
    [
      _c(
        "span",
        {
          staticClass: "margin-left margin-right",
          attrs: { slot: "title" },
          slot: "title",
        },
        [_c("em", [_vm._v("Settings")])]
      ),
      _vm._v(" "),
      _c("api-errors", { attrs: { errors: _vm.errors } }),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-4" }, [
            _c("table", { staticClass: "table" }, [
              _c("colgroup", [
                _c("col", {
                  staticClass: "table-browser-width-30-percent",
                  attrs: { span: "1" },
                }),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-browser-setting-margin" }, [
                  _c("strong", [_vm._v("Page length:")]),
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticClass: "table-browser-setting-margin dropdown" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-default btn-sm dropdown-toggle",
                        attrs: {
                          type: "button",
                          "data-toggle": "dropdown",
                          "aria-haspopup": "true",
                          "aria-expanded": "false",
                        },
                      },
                      [
                        _vm._v(
                          "\n                                " +
                            _vm._s(_vm.mutablePageLength) +
                            " "
                        ),
                        _c("span", { staticClass: "caret" }),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "ul",
                      {
                        staticClass:
                          "dropdown-menu table-browser-dropdown-page-length",
                      },
                      _vm._l(
                        _vm.pageLengthOptions,
                        function (pageLength, index) {
                          return _c(
                            "li",
                            {
                              key: index,
                              staticClass:
                                "table-browser-dropdown-option-margin",
                            },
                            [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.mutablePageLength,
                                    expression: "mutablePageLength",
                                  },
                                ],
                                attrs: { type: "radio", id: "radio-" + index },
                                domProps: {
                                  value: pageLength,
                                  checked: _vm._q(
                                    _vm.mutablePageLength,
                                    pageLength
                                  ),
                                },
                                on: {
                                  change: function ($event) {
                                    _vm.mutablePageLength = pageLength
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "table-browser-dropdown-option-margin-left",
                                  attrs: { for: "radio-" + index },
                                },
                                [
                                  _vm._v(
                                    "\n                                        " +
                                      _vm._s(pageLength) +
                                      "\n                                    "
                                  ),
                                ]
                              ),
                            ]
                          )
                        }
                      ),
                      0
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-browser-setting-margin" }, [
                  _c("strong", [_vm._v("Include alternative names:")]),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-browser-setting-margin" }, [
                  _vm.hasANT
                    ? _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mutableAlternativeNameSetting.included,
                            expression:
                              "mutableAlternativeNameSetting.included",
                          },
                        ],
                        ref: "include-an",
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(
                            _vm.mutableAlternativeNameSetting.included
                          )
                            ? _vm._i(
                                _vm.mutableAlternativeNameSetting.included,
                                null
                              ) > -1
                            : _vm.mutableAlternativeNameSetting.included,
                        },
                        on: {
                          change: [
                            function ($event) {
                              var $$a =
                                  _vm.mutableAlternativeNameSetting.included,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      _vm.mutableAlternativeNameSetting,
                                      "included",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      _vm.mutableAlternativeNameSetting,
                                      "included",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(
                                  _vm.mutableAlternativeNameSetting,
                                  "included",
                                  $$c
                                )
                              }
                            },
                            _vm.updateSelectedANT,
                          ],
                        },
                      })
                    : _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.mutableAlternativeNameSetting.included,
                            expression:
                              "mutableAlternativeNameSetting.included",
                          },
                        ],
                        ref: "include-an",
                        attrs: {
                          type: "checkbox",
                          disabled: "",
                          "data-toggle": "tooltip",
                          title: "No alternative name available",
                        },
                        domProps: {
                          checked: Array.isArray(
                            _vm.mutableAlternativeNameSetting.included
                          )
                            ? _vm._i(
                                _vm.mutableAlternativeNameSetting.included,
                                null
                              ) > -1
                            : _vm.mutableAlternativeNameSetting.included,
                        },
                        on: {
                          change: function ($event) {
                            var $$a =
                                _vm.mutableAlternativeNameSetting.included,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.mutableAlternativeNameSetting,
                                    "included",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.mutableAlternativeNameSetting,
                                    "included",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.mutableAlternativeNameSetting,
                                "included",
                                $$c
                              )
                            }
                          },
                        },
                      }),
                ]),
                _vm._v(" "),
                _c("td", [
                  _vm.mutableAlternativeNameSetting.included
                    ? _c("span", { ref: "selected-ant" }, [
                        _vm._v(" " + _vm._s(_vm.selectedANT) + " "),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _vm.mutableAlternativeNameSetting.included
                ? _c("tr", [
                    _c("td", [
                      _c(
                        "ul",
                        {
                          staticClass:
                            "table-browser-dropdown-menu table-browser-dropdown-alternative-name",
                        },
                        _vm._l(
                          _vm.alternativeNameTypes,
                          function (item, index) {
                            return _c("li", { key: index }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value:
                                      _vm.mutableAlternativeNameSetting
                                        .selected,
                                    expression:
                                      "mutableAlternativeNameSetting.selected",
                                  },
                                ],
                                ref: "ant-option",
                                refInFor: true,
                                attrs: { type: "radio" },
                                domProps: {
                                  value: item[0],
                                  checked: _vm._q(
                                    _vm.mutableAlternativeNameSetting.selected,
                                    item[0]
                                  ),
                                },
                                on: {
                                  change: [
                                    function ($event) {
                                      return _vm.$set(
                                        _vm.mutableAlternativeNameSetting,
                                        "selected",
                                        item[0]
                                      )
                                    },
                                    _vm.updateSelectedANT,
                                  ],
                                },
                              }),
                              _vm._v(
                                "\n                                    " +
                                  _vm._s(item[1]) +
                                  "\n                                "
                              ),
                            ])
                          }
                        ),
                        0
                      ),
                    ]),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("tr", [
                _c("td", { staticClass: "table-browser-setting-margin" }, [
                  _c("strong", [_vm._v("Include federated items:")]),
                ]),
                _vm._v(" "),
                _c("td", { staticClass: "table-browser-setting-margin" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.showFederated,
                        expression: "showFederated",
                      },
                    ],
                    attrs: { type: "checkbox" },
                    domProps: {
                      checked: Array.isArray(_vm.showFederated)
                        ? _vm._i(_vm.showFederated, null) > -1
                        : _vm.showFederated,
                    },
                    on: {
                      change: function ($event) {
                        var $$a = _vm.showFederated,
                          $$el = $event.target,
                          $$c = $$el.checked ? true : false
                        if (Array.isArray($$a)) {
                          var $$v = null,
                            $$i = _vm._i($$a, $$v)
                          if ($$el.checked) {
                            $$i < 0 && (_vm.showFederated = $$a.concat([$$v]))
                          } else {
                            $$i > -1 &&
                              (_vm.showFederated = $$a
                                .slice(0, $$i)
                                .concat($$a.slice($$i + 1)))
                          }
                        } else {
                          _vm.showFederated = $$c
                        }
                      },
                    },
                  }),
                ]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-4 table-browser-border-shadow" }, [
            _c("h3", [_vm._v(" Select visible columns ")]),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table" },
              _vm._l(_vm.mutableVisibleColumnOptions, function (value, column) {
                return _c("tr", { key: value.id }, [
                  _c("td", { staticClass: "padding-top-bottom-small" }, [
                    _c("strong", [_vm._v(_vm._s(value.verbose))]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "padding-top-bottom-small" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.mutableVisibleColumnOptions[column].selected,
                          expression:
                            "mutableVisibleColumnOptions[column].selected",
                        },
                      ],
                      ref: "visible-column-option",
                      refInFor: true,
                      attrs: {
                        id: column,
                        disabled: _vm.checkDisable(column),
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.mutableVisibleColumnOptions[column].selected
                        )
                          ? _vm._i(
                              _vm.mutableVisibleColumnOptions[column].selected,
                              null
                            ) > -1
                          : _vm.mutableVisibleColumnOptions[column].selected,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a =
                                _vm.mutableVisibleColumnOptions[column]
                                  .selected,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.mutableVisibleColumnOptions[column],
                                    "selected",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.mutableVisibleColumnOptions[column],
                                    "selected",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.mutableVisibleColumnOptions[column],
                                "selected",
                                $$c
                              )
                            }
                          },
                          function ($event) {
                            return _vm.updateVisibilityOptions(
                              $event.target,
                              "column"
                            )
                          },
                        ],
                      },
                    }),
                  ]),
                ])
              }),
              0
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-xs-4" }, [
            _c("h3", [_vm._v(" Details column options ")]),
            _vm._v(" "),
            _c(
              "table",
              { staticClass: "table" },
              _vm._l(_vm.mutableVisibleDetailOptions, function (value, option) {
                return _c("tr", { key: value.id }, [
                  _c("td", { staticClass: "padding-top-bottom-small" }, [
                    _c("strong", [_vm._v(_vm._s(value.verbose))]),
                  ]),
                  _vm._v(" "),
                  _c("td", { staticClass: "padding-top-bottom-small" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value:
                            _vm.mutableVisibleDetailOptions[option].selected,
                          expression:
                            "mutableVisibleDetailOptions[option].selected",
                        },
                      ],
                      ref: "details-column-option",
                      refInFor: true,
                      attrs: {
                        id: option,
                        disabled:
                          !_vm.mutableVisibleColumnOptions.shortDefinition
                            .selected,
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(
                          _vm.mutableVisibleDetailOptions[option].selected
                        )
                          ? _vm._i(
                              _vm.mutableVisibleDetailOptions[option].selected,
                              null
                            ) > -1
                          : _vm.mutableVisibleDetailOptions[option].selected,
                      },
                      on: {
                        change: [
                          function ($event) {
                            var $$a =
                                _vm.mutableVisibleDetailOptions[option]
                                  .selected,
                              $$el = $event.target,
                              $$c = $$el.checked ? true : false
                            if (Array.isArray($$a)) {
                              var $$v = null,
                                $$i = _vm._i($$a, $$v)
                              if ($$el.checked) {
                                $$i < 0 &&
                                  _vm.$set(
                                    _vm.mutableVisibleDetailOptions[option],
                                    "selected",
                                    $$a.concat([$$v])
                                  )
                              } else {
                                $$i > -1 &&
                                  _vm.$set(
                                    _vm.mutableVisibleDetailOptions[option],
                                    "selected",
                                    $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                                  )
                              }
                            } else {
                              _vm.$set(
                                _vm.mutableVisibleDetailOptions[option],
                                "selected",
                                $$c
                              )
                            }
                          },
                          function ($event) {
                            return _vm.updateVisibilityOptions(
                              $event.target,
                              "detail"
                            )
                          },
                        ],
                      },
                    }),
                  ]),
                ])
              }),
              0
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("span", { attrs: { slot: "footer" }, slot: "footer" }, [
        _c(
          "button",
          {
            ref: "default-btn",
            staticClass: "btn btn-default pull-left",
            attrs: { type: "button" },
            on: { click: _vm.applyDefaultSettings },
          },
          [
            _c("i", {
              staticClass: "fa fa-refresh",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Reset to default settings\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            ref: "cancel-btn",
            staticClass: "btn btn-default",
            attrs: { type: "button" },
            on: { click: _vm.closeModal },
          },
          [
            _c("i", {
              staticClass: "fa fa-times",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Cancel\n        "),
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            ref: "apply-btn",
            staticClass: "btn btn-primary",
            attrs: { type: "button" },
            on: { click: _vm.applySettings },
          },
          [
            _c("i", {
              staticClass: "fa fa-floppy-o",
              attrs: { "aria-hidden": "true" },
            }),
            _vm._v(" Apply\n        "),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }